/* ForgeExtensionPointModal.tsx generated by @compiled/babel-plugin v0.36.1 */
import "./ForgeExtensionPointModal.compiled.css";
import { ax, ix } from "@compiled/react/runtime";
import React from 'react';
import { IconButton } from '@atlaskit/button/new';
import CrossIcon from '@atlaskit/icon/core/migration/close--cross';
import Modal, { ModalBody, ModalHeader, ModalTitle } from '@atlaskit/modal-dialog';
import { Box } from '@atlaskit/primitives/compiled';
import { getAkModalWidth } from '../utils';
var styles = {
  modalWrapper: "_n3td1ejb"
};
export var ForgeExtensionPointModal = function ForgeExtensionPointModal(props) {
  var _props$modalExtension = props.modalExtension,
    closeModalExtension = _props$modalExtension.closeModalExtension,
    title = _props$modalExtension.title,
    modalWidth = _props$modalExtension.modalWidth,
    shouldCloseOnOverlayClick = _props$modalExtension.shouldCloseOnOverlayClick,
    shouldCloseOnEscapePress = _props$modalExtension.shouldCloseOnEscapePress;
  var akModalWidth = modalWidth ? getAkModalWidth(modalWidth) : undefined;
  return /*#__PURE__*/React.createElement(Modal, {
    shouldCloseOnOverlayClick: shouldCloseOnOverlayClick,
    shouldCloseOnEscapePress: shouldCloseOnEscapePress,
    onClose: closeModalExtension,
    width: akModalWidth
  }, /*#__PURE__*/React.createElement(ModalHeader, null, /*#__PURE__*/React.createElement(ModalTitle, null, title), /*#__PURE__*/React.createElement(IconButton, {
    appearance: "subtle",
    icon: CrossIcon,
    label: "Close Modal",
    onClick: closeModalExtension
  })), /*#__PURE__*/React.createElement(ModalBody, null, /*#__PURE__*/React.createElement(Box, {
    xcss: styles.modalWrapper
  }, props.children)));
};